import { debug } from 'zf-web-infra';
import type { ReactElement } from 'react';
import type { ColumnProps } from 'antd/es/table';
import type { TextProps } from '../types';

export function Text<T>(props: TextProps<T>): ReactElement | null {
  debug.common('Text', props);
  return null;
}

Text.displayName = 'Text';

export function getTextProps<T>(child: ReactElement<ColumnProps<T>>): ColumnProps<T> {
  debug.common('getTextProps');

  return {
    ...child.props
  };
}
